import React from "react";

import {
  Button,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  ListGroupItem,
  ListGroup,
  Container,
  Row,
  Col,
} from "reactstrap";

function SolutionsHeader() {
  return (
    <div className="pricing-4" id="pricing-5">
      <Container>
        <Row>
          <Col className="ml-auto mr-auto text-center" md="6">
            <h1 className="title font-weight-bold">Our Solutions</h1>
            <h4 className="h6 font-weight-bold">
              At CrypTegridy, we offer a wide range of intelligence solutions to safeguard 
              your assets and enhance your strategic decisions. Our expertise spans across 
              various domains, ensuring comprehensive protection and actionable intelligence.
            </h4>
          </Col>
        </Row>
        <Row className="mt-5">
          <Col md="4">
            <Card className="card-pricing card-coin bg-default">
              <CardHeader>
                <img
                  alt="..."
                  className="img-center bg-default border border-info"
                  src={require("assets/img/Logos_Honesty.png")}
                ></img>
              </CardHeader>
              <CardBody className="text-white">
                <Row>
                  <Col className="text-center" md="12">
                    <h5 className="text-uppercase text-info font-weight-bold">Intelligence Solutions</h5>
                  </Col>
                </Row>
                <Row>
                  <ListGroup>
                    <ListGroupItem>Predictive Modeling</ListGroupItem>
                    <hr className="bg-info"></hr>
                    <ListGroupItem>Data Fusion</ListGroupItem>
                    <hr className="bg-info"></hr>
                    <ListGroupItem>Behavioral Analytics</ListGroupItem>
                  </ListGroup>
                </Row>
              </CardBody>
              <CardFooter className="text-center bg-transparent">
                <Button className="mb-3 text-default" color="info" href="/contact-us" onClick={SubmitEvent}>
                  Tailored Intel
                </Button>
              </CardFooter>
            </Card>
          </Col>
          <Col md="4">
            <Card className="card-pricing card-coin bg-default">
              <CardHeader>
                <img
                  alt="..."
                  className="img-center bg-default border border-info"
                  src={require("assets/img/Logos_Regs.png")}
                ></img>
              </CardHeader>
              <CardBody className="text-white">
                <Row>
                  <Col className="text-center" md="12">
                    <h5 className="text-uppercase text-info font-weight-bold">Asset Tracing</h5>
                  </Col>
                </Row>
                <Row>
                  <ListGroup>
                    <ListGroupItem>Blockchain Forensics</ListGroupItem>
                    <hr className="bg-info"></hr>
                    <ListGroupItem>Asset Mapping</ListGroupItem>
                    <hr className="bg-info"></hr>
                    <ListGroupItem>Cross-Chain Analysis</ListGroupItem>
                  </ListGroup>
                </Row>
              </CardBody>
              <CardFooter className="text-center bg-transparent">
                <Button className="mb-3 text-default" color="info" href="/contact-us" onClick={SubmitEvent}>
                  Act Now
                </Button>
              </CardFooter>
            </Card>
          </Col>
          <Col md="4">
            <Card className="card-pricing card-coin bg-default">
              <CardHeader>
                <img
                  alt="..."
                  className="img-center bg-default border border-info"
                  src={require("assets/img/Logos_Privacy.png")}
                ></img>
              </CardHeader>
              <CardBody className="text-white">
                <Row>
                  <Col className="text-center" md="12">
                    <h5 className="text-uppercase text-info font-weight-bold">Due Diligence</h5>
                  </Col>
                </Row>
                <Row>
                  <ListGroup>
                    <ListGroupItem>Risk Profiling</ListGroupItem>
                    <hr className="bg-info"></hr>
                    <ListGroupItem>Compliance Reports</ListGroupItem>
                    <hr className="bg-info"></hr>
                    <ListGroupItem>Reputational Analysis</ListGroupItem>
                  </ListGroup>
                </Row>
              </CardBody>
              <CardFooter className="text-center bg-transparent">
                <Button className="mb-3 text-default" color="info" href="/contact-us" onClick={SubmitEvent}>
                  Intel Report
                </Button>
              </CardFooter>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default SolutionsHeader;
